var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.42822 7.59224L9.53604 5.37122L15.6439 7.59224L12.8676 9.25801V10.9238C12.8676 10.9238 12.1269 10.3685 9.53604 10.3685C6.94521 10.3685 6.2045 10.9238 6.2045 10.9238V9.25801L3.42822 7.59224ZM3.42822 7.59224V12.0343",
    stroke: "#FEC200",
    strokeWidth: 1.66577,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8681 10.3686V11.3558C12.8681 13.2637 11.3767 14.8106 9.5366 14.8106C7.69649 14.8106 6.20507 13.2637 6.20507 11.3558V10.3686M17.6633 13.1782C17.6633 13.1782 18.2019 12.7862 20.0865 12.7862C21.971 12.7862 22.5096 13.1771 22.5096 13.1771M17.6633 13.1782V12.0343L15.6444 10.9238L20.0865 9.25806L24.5285 10.9238L22.5096 12.0343V13.1771M17.6633 13.1782V13.498C17.6633 14.1406 17.9186 14.757 18.3731 15.2114C18.8275 15.6658 19.4438 15.9211 20.0865 15.9211C20.7291 15.9211 21.3455 15.6658 21.7999 15.2114C22.2543 14.757 22.5096 14.1406 22.5096 13.498V13.1771M18.4207 23.1395H22.5351C23.3936 23.1395 24.0754 22.7219 24.6884 22.1378C25.9433 20.9429 23.8833 19.9878 23.0982 19.5203C22.3999 19.1082 21.6246 18.8436 20.8201 18.7429C20.0156 18.6423 19.199 18.7077 18.4207 18.9351M5.5221 18.6152C4.47489 19.2005 1.7286 20.3943 3.40103 21.8879C4.21836 22.6175 5.12787 23.1395 6.27281 23.1395H12.8004C13.9442 23.1395 14.8548 22.6175 15.6722 21.8879C17.3446 20.3943 14.5983 19.2005 13.5511 18.6152C11.0947 17.2437 7.97856 17.2437 5.5221 18.6152Z",
    stroke: "#FEC200",
    strokeWidth: 1.66577,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudents);
export default __webpack_public_path__ + "static/media/students.9091ef7e614afe346d76c0ebe7f64ebe.svg";
export { ForwardRef as ReactComponent };